import axios from './base'

// 预约管理 API（后端 tb_appointment，路由 /appointment）
// 预约由用户在小程序提交（参观访问 / 活动），后台只做 分配人员 / 补录到达时间 / 状态流转，无新增编辑删除
// 取消不走删除：状态置为已取消，记录保留

// 预约列表（keyword/type/status/service_id/date_range 筛选 + 服务端分页；响应带 stats 头部统计）
// service_id=0 表示筛「未分配」；date_range 传数组（axios 序列化为 date_range[]）
export function getAppointmentList(params = {}) {
  return axios.request({
    url: `/appointment`,
    method: 'get',
    params,
  })
}

// 预约详情
export function getAppointmentDetail(id) {
  return axios.request({
    url: `/appointment/${id}`,
    method: 'get',
  })
}

// 分配 / 改派接送人员（data: { service_id }；人员须在职且岗位为接待/接送/讲解）
export function assignAppointment(id, data = {}) {
  return axios.request({
    url: `/appointment/${id}/assign`,
    method: 'put',
    data,
  })
}

// 补录到达时间（data: { arrive_time, emergency_name?, emergency_phone? }；状态 0 补录后自动置 1）
export function arriveAppointment(id, data = {}) {
  return axios.request({
    url: `/appointment/${id}/arrive`,
    method: 'put',
    data,
  })
}

// 状态流转（status：2 标记预约完成 / 3 结束行程 / 4 取消预约；非法流转后端返回中文提示）
export function setAppointmentStatus(id, status) {
  return axios.request({
    url: `/appointment/${id}/status`,
    method: 'put',
    data: { status },
  })
}
